import React, { useState } from "react";
import { collection, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/FirebaseCredential";

export default function UploadExerciseList() {
  const [loading, setLoading] = useState(false);

  // ----------------------------------------------------
  //  YOUR PERMISSIONS JSON LIST
  // ----------------------------------------------------
  const data = [
    {
      id: "accounts_executive.branches",
      resource_id: "branches",
      update: false,
      role_type: "accounts_executive",
      read: true,
      create: false,
      delete: false,
    },

    {
      id: "accounts_executive.classes",
      role_type: "accounts_executive",
      delete: false,
      create: false,
      resource_id: "classes",
      update: false,
      read: true,
    },
    {
      id: "accounts_executive.chat",
      role_type: "accounts_executive",
      delete: false,
      create: true,
      resource_id: "chat",
      update: false,
      read: true,
    },

    {
      id: "accounts_executive.enquiry",
      role_type: "accounts_executive",
      resource_id: "enquiry",
      create: false,
      delete: false,
      update: false,
      read: true,
    },
    {
      id: "accounts_executive.expenses",
      delete: false,
      create: true,
      resource_id: "expenses",
      role_type: "accounts_executive",
      update: false,
      read: true,
    },

    {
      id: "accounts_executive.myattendancereport",
      resource_id: "myattendancereport",
      delete: false,
      read: true,
      create: false,
      role_type: "accounts_executive",
      update: false,
    },
    {
      id: "accounts_executive.members",
      create: false,
      role_type: "accounts_executive",
      update: false,
      resource_id: "members",
      delete: false,
      read: true,
    },
    {
      id: "accounts_executive.expensereport",
      create: true,
      role_type: "accounts_executive",
      update: true,
      resource_id: "expensereport",
      delete: false,
      read: true,
    },

    {
      id: "accounts_executive.packages",
      create: false,
      delete: false,
      resource_id: "packages",
      role_type: "accounts_executive",
      update: false,
      read: true,
    },
    {
      id: "accounts_executive.employeepayrollreport",
      create: false,
      delete: false,
      resource_id: "employeepayrollreport",
      role_type: "accounts_executive",
      update: false,
      read: true,
    },

    {
      id: "accounts_executive.staff",
      delete: false,
      read: true,
      resource_id: "staff",
      role_type: "accounts_executive",
      update: false,
      create: false,
    },
    {
      id: "accounts_executive.paymentreceived",
      delete: false,
      read: true,
      resource_id: "paymentreceived",
      role_type: "accounts_executive",
      update: false,
      create: true,
    },

    {
      id: "accounts_executive.subscription",
      delete: false,
      read: true,
      resource_id: "subscription",
      role_type: "accounts_executive",
      update: false,
      create: false,
    },

    {
      id: "accounts_executive.task",
      delete: false,
      update: true,
      resource_id: "task",
      role_type: "accounts_executive",
      create: true,
      read: true,
    },

    {
      id: "branch_admin.banking",
      resource_id: "banking",
      read: true,
      create: true,
      delete: false,
      role_type: "branch_admin",
      update: false,
    },

    {
      id: "branch_admin.branches",
      read: true,
      create: false,
      update: true,
      role_type: "branch_admin",
      delete: false,
      resource_id: "branches",
    },
    {
      id: "branch_admin.paymentcollection",
      read: true,
      create: true,
      update: false,
      role_type: "branch_admin",
      delete: false,
      resource_id: ".paymentcollection",
    },
    {
      id: "branch_admin.businesshours",
      read: true,
      resource_id: "businesshours",
      role_type: "branch_admin",
      delete: true,
      update: true,
      create: true,
    },
    {
      id: "branch_admin.memberimport",
      read: true,
      resource_id: "memberimport",
      role_type: "branch_admin",
      delete: false,
      update: false,
      create: true,
    },
    {
      id: "branch_admin.classes",
      create: true,
      read: true,
      role_type: "branch_admin",
      update: true,
      delete: true,
      resource_id: "classes",
    },
    {
      id: "branch_admin.classesimport",
      create: true,
      resource_id: "classesimport",
      update: false,
      read: true,
      delete: false,
      role_type: "branch_admin",
    },
    {
      id: "branch_admin.companyprofile",
      role_type: "branch_admin",
      create: false,
      delete: false,
      resource_id: "companyprofile",
      read: true,
      update: false,
    },
    {
      id: "branch_admin.customprefix",
      read: true,
      delete: false,
      role_type: "branch_admin",
      update: false,
      create: false,
      resource_id: "customprefix",
    },
    {
      id: "branch_admin.customemail",
      read: true,
      delete: false,
      role_type: "branch_admin",
      update: false,
      create: false,
      resource_id: "customemail",
    },
    {
      id: "branch_admin.expenses",
      delete: true,
      resource_id: "expenses",
      read: true,
      update: true,
      role_type: "branch_admin",
      create: true,
    },
    {
      id: "branch_admin.gmeetzoom",
      role_type: "branch_admin",
      read: true,
      create: false,
      delete: false,
      resource_id: "gmeetzoom",
      update: false,
    },
    {
      id: "branch_admin.attendanceapi",
      role_type: "branch_admin",
      read: true,
      create: false,
      delete: false,
      resource_id: "attendanceapi",
      update: false,
    },
    {
      id: "branch_admin.googlecalender",
      role_type: "branch_admin",
      read: true,
      delete: true,
      resource_id: "googlecalender",
      update: true,
      create: true,
    },
    {
      id: "branch_admin.formsenquiry",
      role_type: "branch_admin",
      read: true,
      delete: false,
      resource_id: "formsenquiry",
      update: false,
      create: false,
    },
    {
      id: "branch_admin.holiday",
      create: true,
      delete: true,
      read: true,
      update: true,
      resource_id: "holiday",
      role_type: "branch_admin",
    },
    {
      id: "branch_admin.leadintegration",
      create: false,
      resource_id: "leadintegration",
      delete: false,
      read: true,
      role_type: "branch_admin",
      update: false,
    },
    {
      id: "branch_admin.leadstatus",
      create: false,
      resource_id: "leadstatus",
      delete: false,
      read: true,
      role_type: "branch_admin",
      update: false,
    },
    {
      id: "branch_admin.memberattendance",
      delete: false,
      update: false,
      role_type: "branch_admin",
      create: false,
      read: true,
      resource_id: "memberattendance",
    },
       {
      id: "branch_admin.memberattendancesettings",
      delete: false,
      update: false,
      role_type: "branch_admin",
      create: false,
      read: true,
      resource_id: "memberattendancesettings",
    },
    {
      id: "branch_admin.members",
      delete: true,
      create: true,
      update: true,
      role_type: "branch_admin",
      read: true,
      resource_id: "members",
    },
    {
      id: "branch_admin.packageimport",
      role_type: "branch_admin",
      delete: false,
      resource_id: "packageimport",
      create: true,
      update: false,
      read: true,
    },
    {
      id: "branch_admin.packages",
      role_type: "branch_admin",
      delete: true,
      resource_id: "packages",
      create: true,
      update: true,
      read: true,
    },
    {
      id: "branch_admin.payrollsettings",
      update: false,
      delete: false,
      read: true,
      resource_id: "payrollsettings",
      role_type: "branch_admin",
      create: false,
    },
    {
      id: "branch_admin.enquiry",
      update: true,
      delete: true,
      read: true,
      resource_id: "enquiry",
      role_type: "branch_admin",
      create: true,
    },
    {
      id: "branch_admin.myattendancereport",
      update: true,
      delete: true,
      read: true,
      resource_id: "myattendancereport",
      role_type: "branch_admin",
      create: true,
    },
    {
      id: "branch_admin.paymentreceived",
      update: true,
      delete: true,
      read: true,
      resource_id: "paymentreceived",
      role_type: "branch_admin",
      create: true,
    },
    {
      id: "branch_admin.personalprofile",
      update: true,
      delete: true,
      create: true,
      resource_id: "personalprofile",
      role_type: "branch_admin",
      read: true,
    },
    {
      id: "branch_admin.memberreport",
      update: true,
      delete: true,
      create: true,
      resource_id: "memberreport",
      role_type: "branch_admin",
      read: true,
    },
    {
      id: "branch_admin.expensereport",
      update: true,
      create: true,
      read: true,
      role_type: "branch_admin",
      resource_id: "expensereport",
      delete: true,
    },
    {
      id: "branch_admin.routine",
      update: true,
      resource_id: "routine",
      create: true,
      role_type: "branch_admin",
      delete: true,
      read: true,
    },
    {
      id: "branch_admin.task",
      role_type: "branch_admin",
      create: true,
      read: true,
      update: true,
      resource_id: "task",
      delete: true,
    },
    {
      id: "branch_admin.taginequipment",
      role_type: "branch_admin",
      create: false,
      read: true,
      update: false,
      resource_id: "taginequipment",
      delete: false,
    },
    {
      id: "branch_admin.employeepayrollreport",
      role_type: "branch_admin",
      create: true,
      read: true,
      update: true,
      resource_id: "employeepayrollreport",
      delete: true,
    },

    {
      id: "branch_admin.subscription",
      create: false,
      resource_id: "subscription",
      read: true,
      delete: false,
      role_type: "branch_admin",
      update: false,
    },
    {
      id: "branch_admin.chat",
      create: true,
      resource_id: "chat",
      read: true,
      delete: false,
      role_type: "branch_admin",
      update: false,
    },
    {
      id: "branch_admin.equipment",
      role_type: "branch_admin",
      create: true,
      resource_id: "equipment",
      read: true,
      delete: true,
      update: true,
    },
    {
      id: "branch_admin.staff",
      update: true,
      read: true,
      role_type: "branch_admin",
      delete: true,
      create: true,
      resource_id: "staff",
    },

    {
      id: "branch_admin.staffattendance",
      role_type: "branch_admin",
      read: true,
      delete: true,
      resource_id: "staffattendance",
      create: true,
      update: true,
    },
     {
      id: "branch_admin.staffattendancesettings",
      role_type: "branch_admin",
      read: true,
      delete: true,
      resource_id: "staffattendancesettings",
      create: true,
      update: true,
    },

    {
      id: "branch_admin.staffimport",
      resource_id: "staffimport",
      read: true,
      update: false,
      role_type: "branch_admin",
      create: true,
      delete: false,
    },
    {
      id: "branch_admin.vendorimport",
      resource_id: "vendorimport",
      create: true,
      role_type: "branch_admin",
      delete: false,
      read: true,
      update: false,
    },
    {
      id: "branch_admin.equipmentimport",
      resource_id: "equipmentimport",
      create: true,
      role_type: "branch_admin",
      delete: false,
      read: true,
      update: false,
    },
    {
      id: "company_admin.task",
      role_type: "company_admin",
      create: true,
      read: true,
      update: true,
      resource_id: "task",
      delete: true,
    },
    {
      id: "company_admin.banking",
      role_type: "company_admin",
      create: true,
      read: true,
      update: true,
      resource_id: "banking",
      delete: true,
    },
    {
      id: "company_admin.biometric",
      update: true,
      create: true,
      read: true,
      role_type: "company_admin",
      resource_id: "biometric",
      delete: true,
    },
    {
      id: "company_admin.subscription",
      create: true,
      resource_id: "subscription",
      read: true,
      delete: true,
      role_type: "company_admin",
      update: true,
    },
    {
      id: "company_admin.customemail",
      read: true,
      delete: true,
      role_type: "company_admin",
      update: true,
      create: true,
      resource_id: "customemail",
    },
    {
      id: "company_admin.memberreport",
      update: true,
      delete: true,
      create: true,
      resource_id: "memberreport",
      role_type: "company_admin",
      read: true,
    },
    {
      id: "company_admin.leadstatus",
      create: true,
      resource_id: "leadstatus",
      delete: true,
      read: true,
      role_type: "company_admin",
      update: true,
    },
    {
      id: "company_admin.taginequipment",
      role_type: "company_admin",
      create: false,
      read: true,
      update: false,
      resource_id: "taginequipment",
      delete: false,
    },
    {
      id: "company_admin.formsenquiry",
      update: true,
      delete: true,
      create: true,
      resource_id: "formsenquiry",
      role_type: "company_admin",
      read: true,
    },
    {
      id: "company_admin.chat",
      create: true,
      resource_id: "chat",
      read: true,
      delete: true,
      role_type: "company_admin",
      update: true,
    },
    {
      id: "company_admin.expensereport",
      update: true,
      create: true,
      read: true,
      role_type: "company_admin",
      resource_id: "expensereport",
      delete: true,
    },
    {
      id: "company_admin.attendanceapi",
      update: true,
      create: true,
      read: true,
      role_type: "company_admin",
      resource_id: "attendanceapi",
      delete: true,
    },
    {
      id: "company_admin.branches",
      create: true,
      resource_id: "branches",
      read: true,
      delete: true,
      role_type: "company_admin",
      update: true,
    },
    {
      id: "company_admin.myattendancereport",
      create: true,
      resource_id: "myattendancereport",
      read: true,
      delete: true,
      role_type: "company_admin",
      update: true,
    },
    {
      id: "company_admin.employeeattendancereport",
      create: true,
      resource_id: "employeeattendancereport",
      read: true,
      delete: true,
      role_type: "company_admin",
      update: true,
    },
    {
      id: "company_admin.employeepayrollreport",
      create: true,
      resource_id: "employeepayrollreport",
      read: true,
      delete: true,
      role_type: "company_admin",
      update: true,
    },
    {
      id: "company_admin.businesshours",
      update: true,
      read: true,
      delete: true,
      create: true,
      role_type: "company_admin",
      resource_id: "businesshours",
    },
    {
      id: "company_admin.classes",
      read: true,
      resource_id: "classes",
      update: true,
      delete: true,
      role_type: "company_admin",
      create: true,
    },
    {
      id: "company_admin.classesimport",
      read: true,
      delete: true,
      role_type: "company_admin",
      create: true,
      update: true,
      resource_id: "classesimport",
    },
    {
      id: "company_admin.companyprofile",
      resource_id: "companyprofile",
      delete: true,
      update: true,
      role_type: "company_admin",
      create: true,
      read: true,
    },
    {
      id: "company_admin.customprefix",
      update: true,
      read: true,
      delete: true,
      resource_id: "customprefix",
      role_type: "company_admin",
      create: true,
    },
    {
      id: "company_admin.enquiry",
      read: true,
      update: true,
      role_type: "company_admin",
      create: true,
      resource_id: "enquiry",
      delete: true,
    },
    {
      id: "company_admin.equipment",
      role_type: "company_admin",
      create: true,
      resource_id: "equipment",
      read: true,
      delete: true,
      update: true,
    },
    {
      id: "company_admin.equipmentimport",
      resource_id: "equipmentimport",
      update: true,
      create: true,
      role_type: "company_admin",
      read: true,
      delete: true,
    },
    {
      id: "company_admin.expenses",
      create: true,
      resource_id: "expenses",
      role_type: "company_admin",
      delete: true,
      update: true,
      read: true,
    },
    {
      id: "company_admin.gmeetzoom",
      update: true,
      create: true,
      resource_id: "gmeetzoom",
      role_type: "company_admin",
      read: true,
      delete: true,
    },
    {
      id: "company_admin.googlecalender",
      read: true,
      update: true,
      role_type: "company_admin",
      create: true,
      delete: true,
      resource_id: "googlecalender",
    },
    {
      id: "company_admin.holiday",
      resource_id: "holiday",
      delete: true,
      role_type: "company_admin",
      read: true,
      update: true,
      create: true,
    },
    {
      id: "company_admin.invoice",
      resource_id: "invoice",
      delete: true,
      update: true,
      read: true,
      create: true,
      role_type: "company_admin",
    },
    {
      id: "company_admin.leadintegration",
      update: true,
      delete: true,
      read: true,
      create: true,
      resource_id: "leadintegration",
      role_type: "company_admin",
    },
    {
      id: "company_admin.memberattendance",
      role_type: "company_admin",
      read: true,
      resource_id: "memberattendance",
      update: true,
      create: true,
      delete: true,
    },
    {
      id: "company_admin.memberimport",
      delete: true,
      read: true,
      resource_id: "memberimport",
      create: true,
      update: true,
      role_type: "company_admin",
    },
    {
      id: "company_admin.members",
      role_type: "company_admin",
      resource_id: "members",
      delete: true,
      update: true,
      read: true,
      create: true,
    },
    {
      id: "company_admin.packageimport",
      read: true,
      role_type: "company_admin",
      update: true,
      create: true,
      delete: true,
      resource_id: "packageimport",
    },
    {
      id: "company_admin.packages",
      create: true,
      resource_id: "packages",
      role_type: "company_admin",
      update: true,
      delete: true,
      read: true,
    },
    {
      id: "company_admin.paymentcollection",
      read: true,
      role_type: "company_admin",
      create: true,
      resource_id: "paymentcollection",
      delete: true,
      update: true,
    },
    {
      id: "company_admin.paymentreceived",
      read: true,
      update: true,
      delete: true,
      role_type: "company_admin",
      resource_id: "paymentreceived",
      create: true,
    },
    {
      id: "company_admin.payrollsettings",
      delete: true,
      resource_id: "payrollsettings",
      create: true,
      role_type: "company_admin",
      read: true,
      update: true,
    },
    {
      id: "company_admin.personalprofile",
      read: true,
      delete: true,
      role_type: "company_admin",
      resource_id: "personalprofile",
      update: true,
      create: true,
    },
    {
      id: "company_admin.routine",
      role_type: "company_admin",
      update: true,
      read: true,
      create: true,
      delete: true,
      resource_id: "routine",
    },
    {
      id: "company_admin.staff",
      update: true,
      read: true,
      role_type: "company_admin",
      delete: true,
      create: true,
      resource_id: "staff",
    },
    {
      id: "company_admin.staffattendance",
      resource_id: "staffattendance",
      role_type: "company_admin",
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    {
      id: "company_admin.staffimport",
      resource_id: "staffimport",
      role_type: "company_admin",
      read: true,
      create: true,
      delete: true,
      update: true,
    },
    {
      id: "company_admin.vendorimport",
      read: true,
      resource_id: "vendorimport",
      create: true,
      delete: true,
      update: true,
      role_type: "company_admin",
    },
    {
      id: "company_admin.emailtrigger",
      read: true,
      resource_id: "emailtrigger",
      create: true,
      delete: true,
      update: true,
      role_type: "company_admin",
    },

    {
      id: "marketing_executive.memberreport",
      delete: false,
      resource_id: ".memberreport",
      role_type: "marketing_executive",
      create: false,
      update: false,
      read: true,
    },
    {
      id: "marketing_executive.branches",
      create: false,
      resource_id: "branches",
      update: false,
      read: true,
      role_type: "marketing_executive",
      delete: false,
    },

    {
      id: "marketing_executive.classes",
      create: false,
      read: true,
      update: false,
      delete: false,
      resource_id: "classes",
      role_type: "marketing_executive",
    },
    {
      id: "marketing_executive.chat",
      create: true,
      read: true,
      update: false,
      delete: false,
      resource_id: "chat",
      role_type: "marketing_executive",
    },

    {
      id: "marketing_executive.enquiry",
      role_type: "marketing_executive",
      update: true,
      resource_id: "enquiry",
      delete: false,
      create: true,
      read: true,
    },
    {
      id: "marketing_executive.googlecalendar",
      update: true,
      delete: true,
      role_type: "marketing_executive",
      create: true,
      read: true,
      resource_id: "googlecalendar",
    },
    {
      id: "marketing_executive.myattendancereport",
      update: false,
      delete: false,
      role_type: "marketing_executive",
      create: false,
      read: true,
      resource_id: "myattendancereport",
    },

    {
      id: "marketing_executive.members",
      update: false,
      delete: false,
      create: false,
      read: true,
      role_type: "marketing_executive",
      resource_id: "members",
    },

    {
      id: "marketing_executive.packages",
      create: false,
      delete: false,
      role_type: "marketing_executive",
      update: false,
      resource_id: "packages",
      read: true,
    },

    {
      id: "marketing_executive.staff",
      role_type: "marketing_executive",
      delete: false,
      create: false,
      update: false,
      read: true,
      resource_id: "staff",
    },

    {
      id: "marketing_executive.task",
      role_type: "marketing_executive",
      create: true,
      resource_id: "task",
      delete: false,
      update: true,
      read: true,
    },

    {
      id: "marketing_executive.subscription",
      read: true,
      update: false,
      delete: false,
      create: false,
      resource_id: "subscription",
      role_type: "marketing_executive",
    },

    {
      id: "operational_coordinator.branches",
      resource_id: "branches",
      read: true,
      role_type: "operational_coordinator",
      delete: false,
      update: false,
      create: false,
    },

    {
      id: "operational_coordinator.classes",
      role_type: "operational_coordinator",
      read: true,
      create: false,
      update: false,
      resource_id: "classes",
      delete: false,
    },

    {
      id: "operational_coordinator.expenses",
      read: true,
      update: false,
      delete: false,
      create: true,
      role_type: "operational_coordinator",
      resource_id: "expenses",
    },
    {
      id: "operational_coordinator.equipment",
      read: true,
      update: true,
      delete: false,
      create: true,
      role_type: "operational_coordinator",
      resource_id: "equipment",
    },
    {
      id: "operational_coordinator.task",
      read: true,
      update: true,
      delete: false,
      create: true,
      role_type: "operational_coordinator",
      resource_id: "task",
    },
    {
      id: "operational_coordinator.subscription",
      read: true,
      update: false,
      delete: false,
      create: false,
      role_type: "operational_coordinator",
      resource_id: "subscription",
    },
    {
      id: "operational_coordinator.chat",
      read: true,
      update: false,
      delete: false,
      create: true,
      role_type: "operational_coordinator",
      resource_id: "chat",
    },
    {
      id: "operational_coordinator.enquiry",
      read: true,
      update: true,
      delete: false,
      create: true,
      role_type: "operational_coordinator",
      resource_id: "enquiry",
    },
    {
      id: "operational_coordinator.myattendancereport",
      read: true,
      update: false,
      delete: false,
      create: false,
      role_type: "operational_coordinator",
      resource_id: "myattendancereport",
    },
    {
      id: "operational_coordinator.expensereport",
      read: true,
      update: true,
      delete: false,
      create: true,
      role_type: "operational_coordinator",
      resource_id: "expensereport",
    },
    {
      id: "operational_coordinator.expenses",
      read: true,
      update: false,
      delete: false,
      create: true,
      role_type: "operational_coordinator",
      resource_id: "expense",
    },

    {
      id: "operational_coordinator.memberreport",
      resource_id: "memberreport",
      create: false,
      update: false,
      delete: false,
      read: true,
      role_type: "operational_coordinator",
    },
    {
      id: "operational_coordinator.members",
      delete: false,
      role_type: "operational_coordinator",
      resource_id: "members",
      create: false,
      read: true,
      update: false,
    },
    {
      id: "operational_coordinator.employeepayrollreport",
      delete: false,
      role_type: "operational_coordinator",
      resource_id: "employeepayrollreport",
      create: false,
      read: true,
      update: false,
    },

    {
      id: "operational_coordinator.packages",
      delete: false,
      read: true,
      update: false,
      resource_id: "packages",
      role_type: "operational_coordinator",
      create: false,
    },

    {
      id: "operational_coordinator.staff",
      role_type: "operational_coordinator",
      delete: false,
      update: false,
      create: false,
      resource_id: "staff",
      read: true,
    },

    {
      id: "operational_coordinator.paymentreceived",
      role_type: "operational_coordinator",
      delete: false,
      update: false,
      create: true,
      resource_id: "paymentreceived",
      read: true,
    },

    {
      id: "trainer.enquiry",
      read: true,
      update: true,
      resource_id: "enquiry",
      delete: false,
      role_type: "trainer",
      create: true,
    },

    {
      id: "trainer.branches",
      resource_id: "branches",
      delete: false,
      role_type: "trainer",
      create: false,
      update: false,
      read: true,
    },

    {
      id: "trainer.classes",
      update: true,
      delete: false,
      read: true,
      resource_id: "classes",
      create: true,
      role_type: "trainer",
    },

    {
      id: "trainer.chat",
      update: false,
      delete: false,
      read: true,
      resource_id: "chat",
      create: true,
      role_type: "trainer",
    },
    {
      id: "trainer.payrollsettings",
      update: false,
      delete: false,
      read: true,
      resource_id: "payrollsettings",
      create: false,
      role_type: "trainer",
    },

    {
      id: "trainer.googlecalender",
      delete: true,
      read: true,
      resource_id: "googlecalender",
      update: true,
      create: true,
      role_type: "trainer",
    },

    {
      id: "trainer.memberattendance",
      read: true,
      role_type: "trainer",
      delete: false,
      create: false,
      update: false,
      resource_id: "memberattendance",
    },
    {
      id: "trainer.memberreport",
      read: true,
      role_type: "trainer",
      delete: false,
      create: false,
      update: false,
      resource_id: "memberreport",
    },
    {
      id: "trainer.myattendancereport",
      read: true,
      role_type: "trainer",
      delete: false,
      create: false,
      update: false,
      resource_id: "myattendancereport",
    },
    {
      id: "trainer.members",
      read: true,
      role_type: "trainer",
      update: false,
      create: false,
      resource_id: "members",
      delete: false,
    },

    {
      id: "trainer.packages",
      role_type: "trainer",
      update: false,
      resource_id: "packages",
      delete: false,
      create: false,
      read: true,
    },

    {
      id: "trainer.routine",
      role_type: "trainer",
      create: true,
      update: true,
      delete: false,
      resource_id: "routine",
      read: true,
    },
    {
      id: "trainer.task",
      role_type: "trainer",
      create: true,
      update: true,
      delete: false,
      resource_id: "task",
      read: true,
    },
    {
      id: "trainer.subscription",
      role_type: "trainer",
      create: false,
      update: false,
      delete: false,
      resource_id: "subscription",
      read: true,
    },
  ];

 const datalength = data.length

  console.log(datalength) // ----------------------------------------------------
  //  UPLOAD FUNCTION
  // ----------------------------------------------------
  const uploadExerciseList = async () => {


    if (!data || data.length === 0) {
      alert("No permission data found!");
      return;
    }

    setLoading(true);

    try {
      const baseRef = collection(db, "defaultsystempermissions");
      for (let i = 0; i < data.length; i++) {
        const item = data[i];

        if (!item || !item.id) {
          console.warn(`Skipped index ${i}: Missing id`);
          continue;
        }

        const docRef = doc(baseRef, item.id);

        const { id, ...dataWithoutId } = item; // remove id

        await setDoc(docRef, {
          ...dataWithoutId,
        });

        console.log(`Uploaded: ${item.id}`);
      }

      alert("All permission documents uploaded successfully!");
    } catch (error) {
      console.error("Upload Error:", error);
      alert("Error uploading data. Check console.");
    }

    setLoading(false);
  };

  // ----------------------------------------------------
  //  UI
  // ----------------------------------------------------
  return (
    <div style={{ padding: "20px" }}>
      <h2>Permission List Uploader</h2>
      {}

      <button
        onClick={uploadExerciseList}
        disabled={loading}
        style={{
          padding: "10px 20px",
          background: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
        }}
      >
        {loading ? "Uploading..." : "Upload Permission Documents"}
      </button>
    </div>
  );
}
